import { Component } from 'react';

export default class AppErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() { return { failed: true }; }

  render() {
    if (this.state.failed) return <main style={{ padding: 32, maxWidth: 480, margin: '12vh auto', fontFamily: 'system-ui, sans-serif' }}>
      <h1>Полка</h1>
      <p role="alert">Не удалось загрузить экран. Обновите приложение или попробуйте немного позже.</p>
      <button type="button" onClick={() => window.location.reload()} style={{ padding: '12px 20px', border: 0, borderRadius: 12, background: '#181A1B', color: '#fff', cursor: 'pointer' }}>Обновить приложение</button>
    </main>;
    return this.props.children;
  }
}
